import React, { useEffect } from 'react';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { Snackbar } from '@material-ui/core';

function MaterialAlert(props: AlertProps) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

interface Props extends AlertProps {
    error: string;
    message?: string;
    time?: number;
}

const ErrorAlert: React.FC<Props> = ({ time = 6000, error, message, ...props }) => {
    const [open, setOpen] = React.useState(false);
    useEffect(() => (time && String(message)?.trim()?.length > 0 ? setOpen(true) : setOpen(false)), [message, time]);

    const handleSnackbarClose = (e: object, reason: string) => {
        if (reason !== 'clickaway') setOpen(false);
    };

    const handleAlertClose = () => setOpen(false);

    return (
        <>
            {open && (
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    open={open}
                    autoHideDuration={time}
                    onClose={handleSnackbarClose}
                    {...props}
                >
                    <MaterialAlert onClose={handleAlertClose} severity="error">
                        {message || 'There were problems fetching data'}
                    </MaterialAlert>
                </Snackbar>
            )}
        </>
    );
};

export default ErrorAlert;
